import { render, staticRenderFns } from "./DateRangeLegend.vue?vue&type=template&id=0e99116a&scoped=true&"
import script from "./DateRangeLegend.vue?vue&type=script&lang=js&"
export * from "./DateRangeLegend.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeLegend.vue?vue&type=style&index=0&id=0e99116a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e99116a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e99116a')) {
      api.createRecord('0e99116a', component.options)
    } else {
      api.reload('0e99116a', component.options)
    }
    module.hot.accept("./DateRangeLegend.vue?vue&type=template&id=0e99116a&scoped=true&", function () {
      api.rerender('0e99116a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QnAeRhqHcRlA/JS/comp/DateRangeLegend.vue"
export default component.exports